import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { AppService, DentalBidirectionalListItem, DentalReferralForm, GetDentalBidirectionalListsRequest, UpdateReferralReprocessStateRequest } from '../../app.service';
import { AlertService } from '../alert.service';
import { LoadingService } from '../loading.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { catchError, finalize, of, tap } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-reprocess-request-dialog',
  templateUrl: './reprocess-request-dialog.component.html',
  styleUrl: './reprocess-request-dialog.component.scss'
})
export class ReprocessRequestDialogComponent implements OnInit {

  public reprocessReasons: DentalBidirectionalListItem[] =[];
  public referral: DentalReferralForm = null;

  public form: FormGroup;
  public reprocessReasonFormControl: FormControl;
  public reprocessAdditionalDetailsFormControl: FormControl;

  constructor(
    private service: AppService,
    private alert: AlertService,
    //private spinner: LoadingService,
    private dialog: MatDialogRef<ReprocessRequestDialogComponent>,
    private cdr: ChangeDetectorRef, // Inject ChangeDetectorRef
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.referral = this.data.referral;
    console.log(this.referral);
    this.loadLists();
    this.initForm();
  }

  private initForm() {
    this.form = new FormGroup({});
    this.reprocessReasonFormControl = new FormControl('', [Validators.required]);
    this.reprocessAdditionalDetailsFormControl = new FormControl('', [Validators.required]);

    this.form.addControl('reprocessReasonFormControl', this.reprocessReasonFormControl);
    this.form.addControl('reprocessAdditionalDetailsFormControl', this.reprocessAdditionalDetailsFormControl);
  }

  private loadLists() {
    const request = new GetDentalBidirectionalListsRequest();

    // Show the spinner before the request starts
    //this.spinner.show();

    this.service.GetDentalBidirectionalLists(request).pipe(
      tap((result) => {
        if (result.success) {
          this.reprocessReasons = result.lists.find(l => l.name == 'ReprocessReasons').listItems.filter(i => i.active == true);
        } else {
          console.log(`ERROR: ${result.message}`);
        }
      }),
      catchError((error) => {
        console.error(error);
        return of([]); // Return an empty array or appropriate fallback in case of error
      }),
      finalize(() => {
        // Hide the spinner after the request completes, whether it was successful or not
        //this.spinner.hide();
      })
    ).subscribe();
  }

  onClose(): void {
    // Close the dialog without saving changes
    this.dialog.close({ data: { refresh: false } });
  }

  onSave(): void {
    if (this.form.valid) {
      //this.spinner.show();

      const referralToUpdate = new DentalReferralForm();
      
      referralToUpdate.referralType = this.referral?.referralType;
      referralToUpdate.id = this.referral?.id;
      referralToUpdate.reprocess = true;
      referralToUpdate.reprocessReason = this.reprocessReasonFormControl.value;
      referralToUpdate.reprocessAdditionalDetails = this.reprocessAdditionalDetailsFormControl.value;

      const request = new UpdateReferralReprocessStateRequest();
      request.referral = referralToUpdate;

      this.service.UpdateReferralReprocessState(request)
        .pipe(
          finalize(() => {
            // Hide the spinner after the request completes
            //this.spinner.hide();
          })
        )
        .subscribe({
          next: (response) => {
            if (response.success) {
              this.alert.success('Referral sent to reprocessing.');

              // Close the dialog and let parent know to refresh the data.
              this.dialog.close({ data: { refresh: true } });

            } else {
              this.alert.warning(response.message);
            }
          },
          error: (error) => {
            console.error('Error submitting reprocessing request:', error);
            this.alert.error('Failed to submit reprocessing request. Please try again.');
          }
        });
    } else {
      // Mark all fields as touched to show validation errors
      this.form.markAllAsTouched();
      this.alert.warning('Please correct the errors in the form before submitting.');
      console.log('Warning: Please correct the errors in the form before submitting.')
    }
  }


}
